import React, { Fragment, useMemo, useState } from "react";
import { Button, DialogActions, DialogContent, Divider, Grid, IconButton, Typography } from "@material-ui/core";
import DialogTitle from "../../../components/dialog-title";
import { Form, Formik, FieldArray } from "formik";

import { FAutocomplete } from "../../../components/form-elements";

import MuiAutocomplete from "@material-ui/lab/Autocomplete";
import { TextField, CircularProgress } from "@material-ui/core";
import tagsService from "../../../services/tags.service";

export default function FormModalContent({ close, data, extra }) {

    const defaultValues = data?.search_keys ? data?.search_keys.split(" - ").map(item => ({title: item, value: item})) : []
    const [searchKeys, setSearchKeys] = useState(defaultValues)
    const [searchOption, setSearchOption] = useState("")

    const handleSubmit = async () => {
        let dataToSend = {
            searchKey: searchKeys.map(item => item.value)
        }

        await tagsService.editTag(data.id, dataToSend);

        close(true);
    };

    const getOptionLabel = () => {
        const labelSelector = "title";
        if (!labelSelector) return;
        if (typeof labelSelector === "string") {
            return (option) => `${option[labelSelector]}`;
        }
        return labelSelector;
    };


    const options = searchOption.length > 0 ? [{ title: searchOption, value: searchOption }] : []

    return (
        <>
            <DialogTitle onClose={() => close()}>
                ویرایش
            </DialogTitle>
            <Divider />

            <DialogContent>
                <MuiAutocomplete
                    multiple={true}
                    options={options}
                    onKeyUp={(e) => setSearchOption(e.target.value)}
                    getOptionLabel={getOptionLabel()}
                    defaultValue={defaultValues}
                    noOptionsText="هیچ گزینه ای یافت نشد."
                    onChange={(e, values) => setSearchKeys(values)}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            margin="normal"
                            variant="outlined"
                            fullWidth
                            label={"هم خانواده"}
                            InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                    <React.Fragment>
                                        {params.InputProps.endAdornment}
                                    </React.Fragment>
                                ),
                            }}
                        />
                    )}
                />
            </DialogContent>

            <DialogActions>
                <Button onClick={close} color="primary" disabled={false}>
                    لغو
                </Button>
                <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                >
                    ذخیره
                </Button>
            </DialogActions>
        </>
    );
}
